import React from "react";
import "../index.scss";

const SocialLink = () => {
  return (
    <div>
      <div class="social-links">
        <a href="#" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
        <a href="#" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
        <a href="#" target="_blank">
          <i class="fab fa-youtube"></i>
        </a>
        <a href="#" target="_blank">
          <i class="fab fa-tiktok"></i>
        </a>
      </div>
    </div>
  );
};

export default SocialLink;
